import { withTheme } from '@material-ui/core/styles';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { toggleSidebar, seletedSidebarMenus, mouseOverSidebar, mouseOUTSidebar } from '../Layout/LayoutState';
import { checkByRole } from '../../utils/handleSidebar';

import SidebarView from './SidebarView';

const displayedMenus = checkByRole(localStorage.getItem('role'));
export default compose(
  withRouter,
  withTheme(),
  connect(
    (state) => ({
      // isSidebarOpened: localStorage.getItem("role_id") !== '1' ? false : state.layout.isSidebarOpened,
      isSidebarOpened: displayedMenus.length > 0 ? state.layout.isSidebarOpened : false,
    }),
    { toggleSidebar, seletedSidebarMenus, mouseOverSidebar, mouseOUTSidebar },
  ),
  withState('isPermanent', 'setPermanent', true),
  withHandlers({
    handleWindowWidthChange:
      ({ width, isPermanent, setPermanent, theme }) =>
      () => {
        const windowWidth = window.innerWidth;
        localStorage.setItem('windowWidth', windowWidth);
        const breakpointWidth = theme.breakpoints.values.md;
        const isSmallScreen = windowWidth < breakpointWidth;

        if (isSmallScreen && isPermanent) {
          setPermanent(false);
        } else if (!isSmallScreen && !isPermanent) {
          setPermanent(true);
        }
      },
  }),
  lifecycle({
    UNSAFE_componentWillMount() {
      window.addEventListener('resize', this.props.handleWindowWidthChange);
      this.props.handleWindowWidthChange();
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.handleWindowWidthChange);
    },
  }),
)(SidebarView);
